var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center confirm-container container-box-step4"},[_vm._m(0),_c('div',{staticClass:"message-section"},[_c('strong',[_vm._v("¡Gracias por completar el cuestionario!")]),_c('p',[_vm._v("Su número de confirmación es "+_vm._s(_vm.confirmationNumber))])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-section"},[_c('em',{staticClass:"fal fa-check-circle"})])
}]

export { render, staticRenderFns }